module.exports = __webpack_public_path__ + "static/media/vicky1.26546c82.jpg";